module.exports = __webpack_public_path__ + "img/calendar.fd9d3a2f.png";